import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '2rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    _playPauseControls: {
      width: '3rem',
    },
    name: {
      name: 'ชื่อ',
      width: '1fr',
    },
    text: {
      name: 'หัวข้อคำถาม',
      width: '2fr',
    },
    // eslint-disable-next-line
    activated_at: {
      name: 'กดเริ่มไปเมื่อ',
      width: '14rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    // eslint-disable-next-line
    active_for_seconds: {
      name: 'ระยะเวลา (วินาที)',
      width: '6rem',
    },
    totalVote: {
      name: 'ตอบแล้ว (คน)',
      width: '5rem',
    },
    // eslint-disable-next-line
    updated_at: {
      name: 'แก้ไขล่าสุด',
      width: '6rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    _closesControls: {
      width: '4rem',
    },
  },
  sortable: ['name', 'activated_at', 'text', 'updated_at'],
};
